import React from "react";
import {Container, Typography} from "@mui/material";
import Spacer from "./Spacer";
import Footer from "./home/Footer";
import ResponsiveAppBarNew from "./responsive-app-bar-new";

function NoFurtherRenewals(){
    return (<>
        <ResponsiveAppBarNew/>
        <Container maxWidth={"md"}>
            <Spacer height={50}/>
            <Typography align={"center"} variant={"h4"}>Thank you for choosing FylePro for your filing needs.</Typography>
            <Spacer height={50}/>
            <Typography align={"center"}>
                The period for our 2027 renewal service has not yet started. Please check back on December 30th if you would like to complete your 2027 Annual Report renewal.
            </Typography>
            <Spacer height={50}/>
            <Typography align={"center"}>
                You can always reach out to us at <a href={"mailto:helpdesk@fylepro.com"}>helpdesk@fylepro.com</a> with any additional questions.
            </Typography>
        </Container>
        <Spacer height={250}/>
        <Footer/>

    </>);
}

export default NoFurtherRenewals